module.exports = __webpack_public_path__ + "static/img/t6-1.8693f8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/t6-1.png
// module id = jkm5
// module chunks = 1